import { Check } from "lucide-react";

export default function StepProgress({ step, total, labels, testId }) {
  const pct = Math.round((step / total) * 100);
  return (
    <div className="w-full" data-testid={testId}>
      <div className="flex items-center justify-between mb-2 text-xs sm:text-sm" style={{ color: "#475569" }}>
        <span className="font-semibold">Step {step} of {total}</span>
        <span>{labels?.[step - 1]}</span>
      </div>
      <div className="w-full h-2 rounded-full" style={{ background: "#E2EBF1" }}>
        <div
          className="h-2 rounded-full transition-all duration-500 ease-in-out"
          style={{ width: pct + "%", background: "#00A7B5" }}
        />
      </div>
      <div className="mt-3 hidden md:flex items-center justify-between gap-1">
        {labels?.map((l, i) => {
          const done = i + 1 < step;
          const active = i + 1 === step;
          return (
            <div key={l} className="flex-1 flex items-center gap-2 text-xs">
              <span
                className="inline-flex items-center justify-center w-6 h-6 rounded-full font-semibold"
                style={{
                  background: done ? "#0B2D59" : active ? "#00A7B5" : "#E2EBF1",
                  color: done || active ? "#F4F8FB" : "#475569",
                }}
              >
                {done ? <Check className="w-3 h-3" /> : i + 1}
              </span>
              <span className="hidden lg:inline" style={{ color: active ? "#0B2D59" : "#475569", fontWeight: active ? 600 : 400 }}>
                {l}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
